import React, { useContext } from 'react';
import { Table, TableBody, TableCell, TableRow, Checkbox, TableContainer, TableHead, TablePagination, Box, IconButton, Tooltip, } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FileSelectionCtx } from '../../App/ApplicationContext';
import { PROJECTNAME } from '../../../types/searchTypes';
import { parseSize } from '../../../utils/Swirrl/sizeCalculation';
import { filterFiles } from '../../../utils/getFacetsInfo';
const handleSelectionClick = (item, collection) => {
    const selection = collection.find((element) => element.url === item.url)
        ? collection.filter((element) => element.url !== item.url)
        : collection.concat(item);
    return selection;
};
const TableHeader = ({ selectTooltip }) => (React.createElement(TableHead, null,
    React.createElement(TableRow, null,
        React.createElement(TableCell, null,
            "Select",
            React.createElement(Tooltip, { title: selectTooltip, placement: 'top' },
                React.createElement(InfoOutlinedIcon, { fontSize: 'small', style: {
                        marginLeft: 4,
                        verticalAlign: 'middle',
                        cursor: 'default',
                    } }))),
        React.createElement(TableCell, null, "File"),
        React.createElement(TableCell, null, "Download"),
        React.createElement(TableCell, { align: 'center' }, "Size"))));
export const NestedFileTable = ({ files, datasetSelected, deselectDataset, searchQuery, projectName, }) => {
    const [filePage, setFilePage] = React.useState(0);
    const [fileRowsPerPage, setFileRowsPerPage] = React.useState(10);
    const { fileCollection, selectFiles } = useContext(FileSelectionCtx);
    const handleFileChangePage = (event, newPage) => {
        setFilePage(newPage);
    };
    const handleFileChangeRowsPerPage = (event) => {
        setFileRowsPerPage(+event.target.value);
        setFilePage(0);
    };
    const variables = searchQuery.selectedItems
        .filter((item) => item.facetId === 'variable')
        .map((item) => item.fieldId);
    /*
      For CMIP5 we have to remove any files that do not match our 'variable' facet(s)
      As filenames are prefixed with the variable name, we just filter on that prefix
    */
    const matchingFiles = projectName && projectName === PROJECTNAME.CMIP5
        ? filterFiles(files, variables)
        : files;
    return (React.createElement(Box, { margin: 0, style: { padding: '10px 40px' } },
        React.createElement("br", null),
        React.createElement(TableContainer, null,
            React.createElement(Table, { size: 'small', padding: 'none', "aria-label": 'files', style: { fontSize: '12' } },
                React.createElement(TableHeader, { selectTooltip: 'When you select the files they will be added to the link list in metalink format that can be used\n           to programmatically download the files. For example with a metalink client, curl or wget.' }),
                React.createElement(TableBody, null, matchingFiles &&
                    matchingFiles
                        .slice(filePage * fileRowsPerPage, filePage * fileRowsPerPage + fileRowsPerPage)
                        .map((file, index) => {
                        const labelId = `enhanced-table-checkbox-${index}`;
                        const isItemSelected = fileCollection.some((element) => element.url === file.url);
                        return (React.createElement(TableRow, { key: file.instanceId },
                            datasetSelected ? (
                            // If the (full) dataset is selected, lock selection of single files:
                            React.createElement(Checkbox, { disabled: true, checked: true, inputProps: {
                                    'aria-label': 'disabled checked checkbox',
                                } })) : (React.createElement(Checkbox, { onClick: () => {
                                    // Dataset should be deselected when specifc files of it are selected.
                                    deselectDataset();
                                    selectFiles(handleSelectionClick(file, fileCollection));
                                }, checked: isItemSelected, color: 'primary', inputProps: { 'aria-labelledby': labelId } })),
                            React.createElement(TableCell, { component: 'th', scope: 'row' }, file.title),
                            React.createElement(TableCell, { component: 'th', scope: 'row' },
                                React.createElement(IconButton, { component: 'a', href: file.url, download: true, "aria-label": 'download file', size: 'small' },
                                    React.createElement(DownloadIcon, { fontSize: 'small' }))),
                            React.createElement(TableCell, { align: 'center' }, parseSize(file.size))));
                    })))),
        React.createElement(TablePagination, { rowsPerPageOptions: [10, 25, 100], component: 'div', count: matchingFiles.length, rowsPerPage: fileRowsPerPage, page: filePage, onPageChange: handleFileChangePage, onRowsPerPageChange: handleFileChangeRowsPerPage })));
};
